import * as Types from '../actions/auth/ActionTypes';

const initialState = [];

const adminReducer = (state = initialState, action) => {
    const { type, payload } = action;
    console.log('payload', payload);
    
    switch (type) {
    case Types.AUTHENTICATE_USER:
        return payload;
    case Types.CREATE_USER:
        return payload ? [payload] : [{}];
    case Types.CLEAR_AUTH_STATE:
        return [];
    case Types.REDIRECT_TO_HOME:
        return payload;
    default:
        return state;
    }
};

export default adminReducer;